import { cn } from '@/shared/utils/cn/cn.util';

import {
  FORM_CELL_CLASSES,
  FORM_COLUMNS_CLASSES,
  FORM_GRID_CLASSES,
  FORM_SPAN_CLASSES,
} from '../dynamic-form.tokens';
import { type FieldColSpan, type FieldDef, type FormColumns } from '../types/dynamic-form.types';

/**
 * The static half of the span clamp.
 *
 * A field may ask for more tracks than its section will ever open — a shared
 * field list rendered in a one-column settings column, a section narrowed after
 * the field was written. Clamping here, before a class is chosen, means the
 * ramp is only ever asked for a tier the grid actually has; the responsive half
 * (the two ramps switching at the same thresholds) does the rest.
 */
export function fieldColSpan(field: FieldDef, columns: FormColumns): FieldColSpan {
  const requested = field.colSpan ?? 1;

  if (requested === 'full') {
    return 'full';
  }

  return Math.min(requested, columns) as FieldColSpan;
}

/** One section's grid: one column, ramping to its ceiling as the container allows. */
export function sectionGridClasses(columns: FormColumns, className?: string): string {
  return cn(FORM_GRID_CLASSES, FORM_COLUMNS_CLASSES[columns], className);
}

/** One field's cell: the column, the clamped span, then whatever the caller added. */
export function fieldCellClasses(field: FieldDef, columns: FormColumns): string {
  return cn(FORM_CELL_CLASSES, FORM_SPAN_CLASSES[fieldColSpan(field, columns)], field.className);
}
